import type {
  ChartFormatterParams,
  ChartSeriesData,
  ChartTooltip,
  StatisticsCommon,
  WordCloudData,
  WordCloudSeriesData
} from 'types';

import { __t, applyTranslations } from '../../language';

applyTranslations(require('./word-cloud.i18n.json'));

export const NUM_WORD_CLOUD_ITEMS = 30;

const getTooltip = (params: ChartFormatterParams): string => `
  <div class="word-cloud__tooltip">
    <div class="word-cloud__tooltip-label">
      ${params.data.name}
    </div>:&nbsp;
    <div>
      ${params.data.value} ${__t('word_cloud.labels.mentions')}
    </div>
  </div>
`;

const getTooltipData = (): ChartTooltip => ({
  trigger: 'item',
  padding: [10, 20],
  backgroundColor: '#fff',
  borderColor: '#e0e0e0',
  borderWidth: 1,

  textStyle: {
    color: '#3a3a3a',
    lineHeight: 14
  },

  extraCssText: 'box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.14);',
  position: (mousePosition: Array<number>): Array<number> => [mousePosition[0] - 40, mousePosition[1] - 50],
  formatter: (params: ChartFormatterParams): string => getTooltip(params)
});

const getSeriesData = (data: Array<WordCloudSeriesData>, itemLimit: number): Array<ChartSeriesData> => [{
  type: 'wordCloud',
  shape: 'circle',
  gridSize: 12,
  sizeRange: [12, 40],
  rotationRange: [-0, 0],
  width: '90%',
  top: 15,
  textStyle: {
    fontFamily: 'Hind',
    color: '#00b78b'
  },
  emphasis: {
    textStyle: {
      color: '#22866b'
    }
  },
  data: data.slice(0, itemLimit)
}];

export const prepareWordCloudData = (
  data: Array<StatisticsCommon> = [],
  itemLimit: number = NUM_WORD_CLOUD_ITEMS
): WordCloudData => {
  const updatedData = data.map(item => ({
    name: item.label,
    value: item.absolute
  }));

  return {
    tooltip: getTooltipData(),
    series: getSeriesData(updatedData, itemLimit),
    dataLength: updatedData.length
  };
};
